import {useSyncedRef} from "../../../../misc/SyncedRef";
import {useAsyncAction} from "nate-react-api-helpers";
import {useState} from "react";
import {
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Grid,
    Switch,
    TextField
} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {SmoothActionBar} from "../../../../misc/SmoothActionBar";
import {autoFormat} from "../../../project/manage/summary/AutoFormat";

export function EditContactTemplate<U>(props: {
    name: string;
    phone: string;
    email: string;
    title: string;

    gcContact?: boolean;
    pmContact?: boolean;
    emailNotifications?: boolean;

    onClose(value?: U): void;
    onDelete?(): Promise<any>;
    onUpdate(value: {
        name: string;
        phone: string;
        email: string;
        title: string;

        gcContact: boolean;
        pmContact: boolean;
    }): Promise<U>;
}) {
    const onUpdateRef = useSyncedRef(props.onUpdate);
    const onCloseRef = useSyncedRef(props.onClose);

    const update = useAsyncAction(async input => {
        const result = await onUpdateRef.current(input);
        onCloseRef.current(result);
    }, [])

    const onDeleteRef = useSyncedRef(props.onDelete)
    const deleter = useAsyncAction(async () => {
        await onDeleteRef.current?.();
        onCloseRef.current();
    }, []);

    const [name, setName] = useState(props.name);
    const [phone, setPhone] = useState(props.phone);
    const [email, setEmail] = useState(props.email);
    const [title, setTitle] = useState(props.title);
    const [gcContact, setgcContact] = useState(props.gcContact || false);
    const [projectManagerContact, setProjectManagerContact] = useState(props.pmContact || false);
    const [emailNotifications, setEmailNotifications] = useState(props.emailNotifications || false);

    const submit = () => {
        update.callback({
            name: name,
            title: title,
            email: email,
            phone: phone,
            gcContact: gcContact,
            pmContact: projectManagerContact,
            emailNotifications: emailNotifications,
        });
    };

    return (
        <Dialog2 open onClose={() => props.onClose()} onEnterPress={submit}>
            <DialogTitle>Edit Contact</DialogTitle>
            <DialogContent>
                <div style={{height: 8}} />
                <Grid container spacing={2} direction="column">
                    <Grid item>
                        <TextField fullWidth label="Name" value={name} onChange={e => setName(e.target.value)} /></Grid>
                    <Grid item>
                        <TextField fullWidth label="Title" value={title} onChange={e => setTitle(e.target.value)} /></Grid>
                    <Grid item>
                        <TextField label="Email" value={email} onChange={e => setEmail(autoFormat(e.target.value, "email"))} />
                    </Grid>
                    <Grid item>
                        <TextField label="Phone" value={phone} onChange={e => setPhone(autoFormat(e.target.value, "phone"))} />
                    </Grid>
                    {props.gcContact !== undefined && <Grid item>
                        <FormControlLabel control={<Switch checked={gcContact} onChange={(_, checked) => setgcContact(checked)} />} label="Site Contact" />
                    </Grid>}
                    {props.pmContact !== undefined && <Grid item>
                        <FormControlLabel control={<Switch checked={projectManagerContact} onChange={(_, checked) => setProjectManagerContact(checked)} />} label="Project Manager" />
                    </Grid>}
                    {props.pmContact !== undefined && <Grid item>
                        <FormControlLabel control={<Switch checked={emailNotifications} onChange={(_, checked) => setEmailNotifications(checked)} />} label="Email Notifications" />
                    </Grid>}
                </Grid>

            </DialogContent>
            <SmoothActionBar
                loading={update.loading}
                error={update.error || deleter.error}
                onSubmit={submit}
                onCancel={() => props.onClose()}
                onDestroy={props.onDelete ? () => deleter.callback({}) : undefined}
                destroyLoading={deleter.loading}
                destroyName="Delete"
            />
        </Dialog2>
    )
}